/* eslint-disable */
import React, { useContext } from 'react';
import { Data, Filters } from '../contexts';
import { parseMoney } from '../../utils';
import { MonthlyCashFlowValues, CashFlowCommonSizeArrows } from '../report_components/MoneyHelpers';

const MonthlyHistoricCashFlow = (props) => {
    const { monthly_calcs, trailing12 } = useContext(Data);
    const { filters } = useContext(Filters);
    let finalFilters = props.tabFilters || filters;
    const compareWith = finalFilters.compare_with;
    const monthlyCalcs = finalFilters.report_period === 'Trailing 12' ? trailing12 : monthly_calcs;
    const avgCalcs = props.aggregateData && finalFilters.report_period === 'Trailing 12' ? props.aggregateData?.trailing12?.avg : props.aggregateData ? props.aggregateData?.monthly?.avg : monthlyCalcs?.avg;
    const endMonthOfSelectedYear = finalFilters.date_through_monthly_month && finalFilters.date_through_monthly_year ? Number(finalFilters.date_through_monthly_month) : 12

    const selectedYear = finalFilters['year']
    const previousYear = finalFilters['year'] - 1
    const twoYearsAgo = finalFilters['year'] - 2
    let compareSelectedYear = selectedYear;
    let comparePreviousYear = previousYear;
    const calcsYou = monthlyCalcs.you;
    const calcsPeers = compareWith === 'Default:None' ? null : avgCalcs;

    // previousYearCalcs and yoy_calcs are the same
    const previousYearCalcsYou = monthlyCalcs.you;
    // previousYear
    const previousYearCalcsPeers = compareWith === 'Default:None' ? null : avgCalcs;
    const calcsYOYYou = monthlyCalcs.you;
    // 2 years ago
    const previousYOYYou = monthlyCalcs.you;

    const arrowCellClass = props.pdf ? 'common-size-arrow-pdf' : 'common-size-arrow';
    const commonSizeValCellClass = props.pdf ? 'common-size-cell-pdf' : 'common-size-cell';
    const monthNames = Object.values(props.monthsObj);
    let monthsAvailable = 0;
    const useableMonths = calcsYou?.cash?.[selectedYear] ? Object.values(calcsYou.cash[selectedYear]).slice(0, endMonthOfSelectedYear) : [];
    useableMonths.forEach((thing) => (thing !== null ? (monthsAvailable += 1) : null));
    let passedCalcs = null;

    if (compareWith === 'Default:Peers') {
        passedCalcs = calcsPeers;
    } else if (compareWith === 'Default:YOY') {
        passedCalcs = previousYearCalcsYou;
        compareSelectedYear = previousYear
    } else if (compareWith && compareWith.includes('Forecast')) {
        passedCalcs = props.forecastVals;
        compareSelectedYear = props.forecastVals?.['total_revenue'] ? Object.keys(props.forecastVals['total_revenue'])[0] : null
    }

    const CommonSizeArrowsHelper = (props) => {
        if (_.isNumber(props.totalValueYou) && _.isNumber(props.totalValueCompare)) {
            let arrow;
            const totalRevenueYou = calcsYou?.total_revenue?.[selectedYear]
                ? Object.values(calcsYou.total_revenue[selectedYear]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b, 0)
                : 0;

            const totalRevenueCompareTo = props.passedCalcs?.total_revenue?.[selectedYear]
                ? Object.values(props.passedCalcs.total_revenue[selectedYear]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b, 0)
                : 0;
            const you = totalRevenueYou ? props.totalValueYou / totalRevenueYou : 0;
            const compareTo = totalRevenueCompareTo ? props.totalValueCompare / totalRevenueCompareTo : 0;
            arrow = CashFlowCommonSizeArrows(you, compareTo, props.keyArrBuilder);

            if ((compareTo && arrow === 'better') || (compareTo && arrow === 'best')) {
                arrow = (
                    <p className="common-size-arrow-green" style={{ margin: 0, color: 'green' }}>
                        &#9650;
                    </p>
                );
            } else if ((compareTo && arrow === 'worse') || (compareTo && arrow === 'worst')) {
                arrow = (
                    <p className="common-size-arrow-red" style={{ margin: 0, color: 'red' }}>
                        &#9660;
                    </p>
                );
            } else {
                arrow = '';
            }
            return (
                <td className={arrowCellClass} style={props.style}>
                    {arrow}
                </td>
            );
        }
        return <td className={arrowCellClass} />;
    }

    const MonthlyCommonSized = (props) => {
        if (props.passedCalcs && _.isNumber(props.totalValue)) {
            const totalRevenue = props.passedCalcs?.total_revenue?.[selectedYear]
                ? Object.values(props.passedCalcs.total_revenue[selectedYear]).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b, 0)
                : 0;
            return (
                <td className={commonSizeValCellClass} style={props.style}>
                    {totalRevenue ? `${((props.totalValue / totalRevenue) * 100).toFixed(2)}%` : ''}
                </td>
            );
        }
        if (props.totalValue === undefined) {
            // For hiding Cash flow from operating activities:, investing activities:, etc.
            return <td className={commonSizeValCellClass} />;
        }
        return <td className={commonSizeValCellClass}>-</td>;
    }

    const buildRows = () => {
        const allRows = [];
        const cashFlowRows = [];
        props.rows.forEach((row) => {
            let newRow = null;
            // calcsYou, you, selectedYear = monthlyCalcs.you;
            // previousYearCalcsYou, you, previousYear = monthlyCalcs.you;
            // calcsPeers, null or avg, selectedYear = compareWith === 'Default:None' ? null : avgCalcs;
            // previousYearCalcsYou, you, previousYear = monthlyCalcs.you;
            // previousYearCalcsPeers, null or avg, previousYear = compareWith === 'Default:None' ? null : avgCalcs;
            // calcsYOYYou, you, previousYear = monthlyCalcs.you;
            // previousYOYYou, you, twoYearsAgo = monthlyCalcs.you;
            if (compareWith === 'Default:None') {
                let { youValues } = MonthlyCashFlowValues(row.key, calcsYou, selectedYear, previousYear, null, null, null)
                newRow = { ...row, you: youValues, compare: null }
            } else if (compareWith === 'Default:Peers') {
                let { youValues, compareValues } = MonthlyCashFlowValues(row.key, calcsYou, selectedYear, previousYear, calcsPeers, selectedYear, previousYear)
                newRow = { ...row, you: youValues, compare: compareValues }
            } else if (compareWith === 'Default:YOY') {
                let { youValues, compareValues } = MonthlyCashFlowValues(row.key, calcsYou, selectedYear, previousYear, calcsYOYYou, previousYear, twoYearsAgo)
                newRow = { ...row, you: youValues, compare: compareValues }
            } else if (compareWith && compareWith.includes('Forecast')) {
                let compareSelectedYear = props.forecastVals?.['total_revenue'] ? Object.keys(props.forecastVals['total_revenue'])[0] : null
                let { youValues, compareValues } = MonthlyCashFlowValues(row.key, calcsYou, selectedYear, previousYear, props.forecastVals, compareSelectedYear, previousYear, true)
                newRow = { ...row, you: youValues, compare: compareValues }
            }
            if (newRow) {
                cashFlowRows.push(newRow);
            }
        });

        return cashFlowRows.map((row, i) => {
            const borderKeys = [
                'Net cash flow from operating activities',
                'Net cash flow from investing activities',
                'Net cash flow from financing activities',
            ];
            const paddingTopKeys = [
                'Cash flow from investing activities:',
                'Cash flow from financing activities:',
                'Net change in cash and cash equivalents',
                'Cash at beginning of period',
                'Cash at end of period',
            ];
            let copyClassName = '';
            const borderTopStyle = borderKeys.includes(row.copy)
                ? { borderTop: 'solid 1px', minHeight: '17px', paddingBottom: '17px' }
                : { borderTop: 'none' };
            let metricNameStyle;
            const paddingTopStyle = { paddingTop: '3px' };
            let fontStyle = { textAlign: 'left' };
            let youTotalValue;
            let compareTotalValue;
            const youVals = row.you;
            const compareVals = row.compare;

            if (row.key === 'cash_beginning_period') {
                compareTotalValue = compareVals ? compareVals[1] : null;
                youTotalValue = youVals ? youVals[1] : null;
            } else if (row.key === 'cash_end_period') {
                const getAllValues = youVals ? Object.values(youVals).slice(0, endMonthOfSelectedYear) : 0;
                const indexOfNullValue = getAllValues.indexOf(null);
                compareTotalValue =
                    compareVals && indexOfNullValue >= 0
                        ? compareVals[indexOfNullValue]
                        : compareVals && compareVals.hasOwnProperty(12)
                            ? compareVals[12]
                            : null;
                youTotalValue =
                    youVals && indexOfNullValue >= 0
                        ? youVals[indexOfNullValue]
                        : youVals && youVals.hasOwnProperty(12)
                            ? youVals[12]
                            : null;
            } else {
                const numberOfKeys = youVals ? Object.keys(youVals).length : 0;
                if (numberOfKeys) {
                    compareTotalValue = compareVals
                        ? Object.values(compareVals)
                            .slice(0, endMonthOfSelectedYear)
                            .reduce((a, b) => a + b, 0)
                        : 0;
                    youTotalValue = youVals ? Object.values(youVals).slice(0, endMonthOfSelectedYear).reduce((a, b) => a + b, 0) : 0;
                }
            }

            props.pdf ? (copyClassName = 'monthly-cash-flow-copy') : (fontStyle.minWidth = '224px');

            if (props.pdf && paddingTopKeys.includes(row.copy)) {
                paddingTopStyle.paddingTop = '8px';
            } else if (paddingTopKeys.includes(row.copy)) {
                paddingTopStyle.paddingTop = '20px';
            }

            const cashCopyName = row.copy.toLowerCase().includes('cash');

            if (props.pdf && cashCopyName) {
                fontStyle = { ...fontStyle, fontWeight: 'bold', fontSize: '10px', paddingLeft: 0 };
            } else if (cashCopyName) {
                fontStyle = { ...fontStyle, fontWeight: 'bold', fontSize: '12px', paddingLeft: 0 };
            } else {
                fontStyle = { ...fontStyle, fontWeight: 'none', paddingLeft: '18px' };
            }

            const totalFontBold = { fontWeight: 'bold' };
            const totalStyles = { ...totalFontBold, ...paddingTopStyle };
            metricNameStyle = { ...fontStyle, ...paddingTopStyle };

            const zeroMonths = [];
            for (i = 0; i <= 12 + 1; i++) {
                (compareTotalValue === 0 && youVals[i] === 0) ||
                    (compareTotalValue === 0 && youVals[i] === null)
                    ? zeroMonths.push(i)
                    : null;
            }

            const rowChecked =
                row.displayChart && row.checked && props.editMetrics ? (
                    <p style={{ margin: 0 }}>&#10004;</p>
                ) : (
                    ''
                );
            const hideRow = zeroMonths.length === 12 || !row.monthlyView;
            const rowStyle = hideRow ? { display: 'none' } : borderTopStyle;

            return (
                <tr
                    key={row.key + Math.random(89)}
                    style={rowStyle}
                    onClick={() =>
                        props.editMetrics
                            ? props.handleSelectAndLayout('money', 'cash_flow', row.relatedCheckedKey)
                            : null
                    }
                >
                    {!props.pdf ? <td>{rowChecked}</td> : null}
                    <td key={`${i}-name`} className={copyClassName} style={metricNameStyle}>
                        {row.copy}
                    </td>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((v, i) => <td key={`${i}-${row.key}`} style={paddingTopStyle}>{youVals && v <= endMonthOfSelectedYear ? parseMoney(youVals[v]) : ''}</td>)}
                    {props.page !== 'money' || [0, 12, 16].includes(i) ? (
                        <td key={`${Math.random(i)}-you-total`} style={totalStyles} />
                    ) : (
                        <td key={`${i}-you-total`} style={totalStyles}>
                            {parseMoney(youTotalValue)}
                        </td>
                    )}
                    {props.page !== 'money' || [0, 12, 16].includes(i) ? (
                        <td key={Math.random(i)} className={commonSizeValCellClass} style={paddingTopStyle} />
                    ) : (
                        <MonthlyCommonSized
                            totalValue={youTotalValue}
                            passedCalcs={calcsYou}
                            year={selectedYear}
                            style={paddingTopStyle}
                        />
                    )}
                    {compareWith === 'Default:None' ? null : props.page !== 'money' ||
                        [0, 12, 16].includes(i) ? (
                        <td key={Math.random(i)} className={arrowCellClass} style={paddingTopStyle} />
                    ) : (
                        <CommonSizeArrowsHelper
                            totalValueYou={youTotalValue}
                            totalValueCompare={compareTotalValue}
                            style={paddingTopStyle}
                            keyArrBuilder={row.key}
                            passedCalcs={passedCalcs}
                            year={compareSelectedYear}
                        />
                    )}
                    {compareWith && compareWith.includes('Forecast') && [0, 12, 16].includes(i) ? (
                        <td key={`${Math.random(i)}-compare-total`} style={totalStyles} />
                    ) : compareWith && compareWith.includes('Forecast') ? (
                        <td key={`${i}-compare-total`} style={totalStyles}>
                            {parseMoney(compareTotalValue)}
                        </td>
                    ) : null}
                    {compareWith === 'Default:None' ? null : props.page !== 'money' ||
                        [0, 12, 16].includes(i) ? (
                        <td key={Math.random(i)} className={commonSizeValCellClass} style={paddingTopStyle} />
                    ) : (
                        <MonthlyCommonSized
                            totalValue={compareTotalValue}
                            passedCalcs={passedCalcs}
                            year={compareSelectedYear}
                            style={paddingTopStyle}
                        />
                    )}
                </tr>
            );
        });
    };

    const rows = buildRows();
    let numberCompare;
    if (compareWith === 'Default:YOY' || compareWith === 'YOY' || (compareWith && compareWith.includes("Forecast"))) {
        numberCompare = 'n = 1';
    } else {
        numberCompare = `n = ${props.aggregateData?.monthly_avg_n?.[selectedYear] ?? 0}`;
    }

    const YOYyearDisplay = props.calendarYearEnd ? previousYear : selectedYear;
    const firstTotal = finalFilters.report_period === 'Trailing 12' ? `T12 ${selectedYear}` : 'Total';
    const firstPercent =
        finalFilters.report_period === 'Trailing 12' ? `You T12 ${selectedYear}` : 'You YTD';
    let secondPercent = null;
    if (compareWith && compareWith.includes('Forecast') && finalFilters.report_period !== 'Trailing 12') {
        secondPercent = props.monthlyCompareWithTitle;
    } else if (compareWith === 'Default:Peers' && finalFilters.report_period !== 'Trailing 12') {
        secondPercent = 'Peers Avg';
    } else if (compareWith === 'Default:YOY' && finalFilters.report_period !== 'Trailing 12') {
        secondPercent = `YOY ${YOYyearDisplay}`;
    } else if (finalFilters.report_period === 'Trailing 12' && compareWith !== 'Default:None') {
        secondPercent = `T12 ${previousYear}`;
    }

    const buildMonthlyCashFlowTable = () => {
        if (props.pdf) {
            const pageViewClass = 'landscape-view';
            let clientNames = props.realName ? `${props.realName} / ${props.clientName}` : props.clientName
            const tabName = (props.tabName || props.title || '').trim().toLowerCase();
            const title = (props.title || '').trim().toLowerCase();
            let reportTitle = tabName.includes(title) ? props.tabName || props.title : `${props.tabName}, ${props.title}`;
            let naicsCode = finalFilters.code;
            let dataType = finalFilters.datatype;
            let revenueBand = finalFilters.revenue_band;
            let region = finalFilters.region;
            let numOfDocs = finalFilters.number_of_pros || 'All'
            let reportPeriod = finalFilters.report_period;
            const compareParts = finalFilters.compare_with.split(':');
            let compare = compareParts.length > 1 ? compareParts.slice(1).join(':').trim() : finalFilters.compare_with;
            let filtersTitle = `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Report Period: ${reportPeriod}, Compare with: ${compare}`;

            return (
                <div className={pageViewClass}>
                    <div className="report-pdf-landscape">
                        <div>
                            <div>
                                <p className='report-annual-title'>{`${reportTitle}, ${clientNames}, ${finalFilters.year}`}</p>
                                <p className='report-filters-title'>{filtersTitle}</p>
                            </div>
                            <div className="money-pdf-table-div">
                                <table
                                    id="monthly-cash-flow-pdf"
                                    className="money-monthly-pdf-table"
                                    style={{ whiteSpace: 'pre' }}
                                >
                                    <thead>
                                        <tr>
                                            <td />
                                            {monthNames.map((month) => (
                                                <td key={Math.random(89)}>{month}</td>
                                            ))}
                                            <td style={{ fontWeight: 'bold' }}>{firstTotal}</td>
                                            <td className={commonSizeValCellClass}>{firstPercent}</td>
                                            {compareWith === 'Default:None' ? null : <td className={arrowCellClass} />}
                                            {secondPercent ? (
                                                <td className={commonSizeValCellClass}>{secondPercent}</td>
                                            ) : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows}
                                        <tr>
                                            <td className="footer-cell">
                                                <i>{numberCompare}</i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <p className="pdf-disclaimer-text">{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
                    </div>
                </div>
            );
        }
        return (
            <div className="money-report-card monthly-sheet">
                <div className="money-report-container">
                    <table className="monthly-report-table sheets" id="monthly-cash-flow">
                        <thead>
                            <tr>
                                <td className="edit-metrics-cell" onClick={() => props.handleEditMetrics()}>
                                    {props.editMetrics ? (
                                        <i className="fa fa-save hide-on-print" style={{ fontSize: '2em' }} />
                                    ) : (
                                        <i
                                            className="fa fa-pencil edit-icon hide-on-print"
                                            style={{ fontSize: '2em' }}
                                        />
                                    )}
                                </td>
                                <td />
                                {monthNames.map((month) => (
                                    <td key={Math.random(89)}>{month}</td>
                                ))}
                                <td style={{ fontWeight: 'bold' }}>{firstTotal}</td>
                                <td className="common-size-cell">{firstPercent}</td>
                                {compareWith === 'Default:None' ? null : <td className="common-size-arrow" />}
                                {secondPercent ? <td className="common-size-cell">{secondPercent}</td> : null}
                            </tr>
                        </thead>
                        <tbody>{rows}</tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <i>{numberCompare}</i>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    };

    return buildMonthlyCashFlowTable();
};

export default MonthlyHistoricCashFlow;
